import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleLogin } from '@react-oauth/google';


// MUI Imports
import Typography from "@mui/material/Typography";

// Asset Imports
import scLogo from "../../../Assets/img/scLogo.png";

// Interactive Imports
import LoginError from "../../../Components/Interactive/LoginError";

// Redux Imports
import { login } from "../../../Redux/Actions/userActions";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showing, setIsShowing] = useState(false);
  const auth = useSelector(({ auth }) => auth);

  useEffect(() => {
    if (auth && auth.userInfo) {
      if (!auth.userInfo.isAuth) {
        setIsShowing(true);
      } else {
        if (location.state && location.state.next) {
          navigate(location.state.next);
        } else {
          navigate("/Home");
        }
      }
    }
  }, [auth, navigate, location]);

  const handleSuccess = (credentialResponse) => {
    // Send the signed token itself. The server derives the email and picture from it
    // after verifying with Google, so neither is accepted from the client.
    dispatch(login({ credential: credentialResponse.credential }));
  };

  return (
    <div className="page login-page">
      {showing && (
        <LoginError userInfo={auth.userInfo} setIsShowing={setIsShowing} />
      )}
      <img
        src={scLogo}
        alt="Scalable Commerce Logo"
        style={{ marginBottom: "2rem" }}
      />
      <Typography style={{ marginBottom: "3rem" }} variant="h3">
        Welcome
      </Typography>
      <GoogleLogin
        text="Login with Google"
        onSuccess={handleSuccess}
        onError={(data) => console.log(data)}
      />
    </div>
  );
};

export default Login;
